import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';
import { DragulaService } from 'ng2-dragula/ng2-dragula'
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ContractService } from '../service/contract.service';
import { environment } from './../../environments/environment';
import * as firebase from 'firebase';
import { longStackSupport } from '../../../node_modules/@types/q';
import { NgxSpinnerService } from 'ngx-spinner';
import * as $ from 'jQuery';

@Component({
  selector: 'app-contract-list',
  templateUrl: './contract-list.component.html',
  styleUrls: ['./contract-list.component.css']
})
export class ContractListComponent implements OnInit {

  contractCategories: any = [
      { id: 1, name:'RADNO PRAVO - ugovori, otkazi, sporazumi, izjave (ukoliko nije donesen Pravilnik o radu - manje od 20 radnika)'},
      { id: 11,name:'RADNO PRAVO - ugovori, otkazi, sporazumi, izjave (ukoliko je donesen Pravilnik o radu - 20 i više radnika)'},
      { id: 14,name:'RADNO PRAVO - pravilnici'},
      { id: 3, name:'RADNO PRAVO - odluke, zahtjevi, suglasnosti, potvrde' },
      { id: 17, name:'RADNO PRAVO - dopisi prema radničkom vijeću i tijelima državne uprave' },
      { id: 15,name:'POSEBNI UGOVORI VEZANI UZ RADNE ODNOSE - stipendiranje, obrazovanje radnika, ugovori vezani uz rad direktora i menadžera'},
      { id: 4, name:'FINANCIJE I KNJIGOVODSTVO - neoporezive isplate, fiskalizacija, blagajna, likvidatura, GFI, amortizacija, inventura'},
      { id: 7, name:'DOPISI - obračun plaće, ovršni postupak, prekršajni postupak'},
      { id: 5, name:'UGOVORI - općenito'},
      { id: 16,name:'TRGOVAČKI UGOVORI'},
      { id: 2, name:'OBRAČUNSKA PLAĆANJA - promjene na strani vjerovnika (cesije) i dužnika, asignacija i ugovorna kompenzacija'},
      { id: 6, name:'OVRŠNO PRAVO'},
      { id: 8, name:'PUNOMOĆI, ZAPISNICI'},
      { id: 9, name:'GDPR - ZAŠTITA OSOBNIH PODATAKA'},
      { id: 10,name:'ZAŠTITA NA RADU'},
      { id: 12,name:'IZRADI VLASTITI DOKUMENT - odluka, ugovor, dopis'},
      { id: 13,name:'NAJAVE - DOKUMENTI U IZRADI'},
    ];
  
    categoryState: any = {
      1: true,
      2: true,
      3: true,
      4: true,
      5: true,
      6: true,
      7: true,
      8: true,
      9: true,
      10:true,
      11:true,
      12:true,
      13:true,
      14:true,
      15:true,
      16:true,
      17:true,
  };

  templates: any = [];
  contracts: any = [];
  modalRef: BsModalRef;
  articleToDelete: number = null;

  useremail : string = '';
  userpwd   : string = '';
  modalText : string = 'Link za prijavu putem kojega kao korisnik pristupate aplikaciji poslan je na upisanu e-mail adresu. Ukoliko ste ostali prijavljeni na drugom uređaju, link neće biti poslan na vašu e-mail adresu te prijava neće biti moguća dok se ne odjavite.';
  userlogged: boolean = false;


  @ViewChild('template')
  private deleteMsgTemplate: TemplateRef<any>;

  constructor(private contractService: ContractService, private modalService: BsModalService, private spinner: NgxSpinnerService, private router: Router,private route: ActivatedRoute,private dragulaService: DragulaService,) {
    // TESTIRANJE - DMILIC
    // router.events.subscribe((val) => {
    //   if (val instanceof NavigationEnd){
    //     (<any>window).spinner = this.spinner;
    //     this.spinner.show();
    //     // $('*').addClass('loading-links');
    //     setTimeout(()=>{
    //       $.each($(".statement-textarea"), function (i, element) {
    //         element.style.height = 'auto';
    //         element.style.height = element.scrollHeight + "px";
    //       });
    //       if (!!$('.local-link').length)  $('.local-link').each(function (index, el) {
    //           $(el).click(function (e) {
    //             e.preventDefault();
    //             let params = $(el).attr('href').split('?');
    //             params = params[params.length - 1];
    //             params = params.split('=');
    //             let queries = {};
    //             queries[params[0]] = params[1];

    //             (<any>window).router.navigate(['/contract'], { queryParams: queries });
    //           })
    //       }, 2000);
    //       setTimeout(() => {
    //         (<any>window).spinner.hide();
    //       }, 2000);
    //     })
    //   }
    // })
    }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  ngOnLoad() {}
    
  // TESTIRANJE - DMILIC
          // // preuzeto s contract.component (M. Petric radio) $('*').addClass('loading-links');
          // bindLinks() {
          //   $('.local-link').each(function (index, el) {
          //     $(el).click(function (e) {
          //       e.preventDefault();
          //       let params = $(el).attr('href').split('?');
          //       params = params[params.length - 1];
          //       params = params.split('=');
          //       let queries = {};
          //       queries[params[0]] = params[1];
        
          //       (<any>window).router.navigate(['/contract'], { queryParams: queries });
          //     })
          //   })
          // }

  ngOnInit() {

    if(environment.production) {
      firebase.auth().onAuthStateChanged( user => {
        if (!user) {
          console.log('logout onAuthStateChanged',user);
          // firebase.database().ref('/loggedInUsers/' + this.useremail.split('@')[0] + this.useremail.split('@')[1].split('.').join('')).remove();
          this.userlogged = false;
          this.useremail = '';
        } else {
          console.log('login onAuthStateChanged',user);
          this.userlogged = true;
          this.useremail = user.email;
          // firebase.database().ref('/loggedInUsers/').once('value').then(function (snapshot) {
          //   if (Object.values(snapshot.val() || {}).map(element => element['email'].toLowerCase()).includes(user.email.toLowerCase())) {
          //     // firebase.auth().signOut()
          //     firebase.database().ref('/loggedInUsers/' + user.email.split('@')[0] + user.email.split('@')[1].split('.').join('')).remove();
          //   } else {
          //     firebase.database().ref('/loggedInUsers/' + user.email.split('@')[0] + user.email.split('@')[1].split('.').join('')).set({
          //       email: user.email,
          //     });
          //   }
          // })
        }
      });
    } else {
      // Local env
      
      this.userlogged = true;
      this.useremail = 'development@selflegal.local';
    }

    this.templates = this.contractService.getTemplates();
    this.contracts = this.contractService.getContracts();
  }

  login(){
      console.log('login ... 555555 ', this.useremail);

      var actionCodeSettings = {
        // URL you want to redirect back to. The domain (www.example.com) for this
        // URL must be whitelisted in the Firebase Console.
        url: window.location.href,
        // This must be true.
        handleCodeInApp: true,
      };

      console.log('555555555555');
console.log('/loggedInUsers/' + this.useremail.replace(/[^0-9a-z]/gi, ''));

   //   firebase.database().ref('/loggedInUsers/' + this.useremail.replace(/[^0-9a-z]/gi, '')).once("value").then(logged => {
        firebase.database().ref('/loggedInUsers/' + this.useremail.replace(/[^0-9a-z]/gi, '')).once("value").then(logged => {

        console.log('logged kkkkkkkkk',logged.val());

      if (logged.val() === null ) { console.log('no loggedInUser '); }
      else {
        console.log('tusam kkkkkk');
        firebase.auth().sendSignInLinkToEmail(this.useremail, actionCodeSettings)
          .then(function () {
            // The link was successfully sent. Inform the user.
            // Save the email locally so you don't need to ask the user for it again
            // if they open the link on the same device.
            window.localStorage.setItem('emailForSignIn', this.useremail);
          })
          .then(function () {
            // console.log(firebase.database().ref('/loggedInUsers/').once('value'))
          })
          .catch(function (error) {
            // Some error occurred, you can inspect the code: error.code
          });
      }
    });


      }

  logout(){

    console.log('signOut ...');
    firebase.auth().signOut();
    //firebase.database().ref('/loggedInUsers/' + this.useremail.replace(/[^0-9a-z]/gi, '')).remove();
  }

  logoutWindowClose() {
    console.log('signOut ...');
    firebase.auth().signOut();
    //firebase.database().ref('/loggedInUsers/' + this.useremail.replace(/[^0-9a-z]/gi, '')).remove();
  }

  /**
   * Deletes the contract.
   * @param {string} id
   */
  deleteContract = id => {
    console.log('Deleting contract <' + id + '>');
    this.articleToDelete = id;
    this.modalRef = this.modalService.show(this.deleteMsgTemplate);
  }

  /**
   * Handles delete contract modal confirm.
   */
  confirm(): void {
    if (this.articleToDelete) {
      this.contractService.deleteContract(this.articleToDelete);
      this.contracts = this.contractService.getContracts();
      this.articleToDelete = null;
    }

    this.modalRef.hide();
  }

  /**
   * Handles delete contract modal cancel.
   */
  decline(): void {
    this.modalRef.hide();
  }
}


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contract-list/contract-list.component.ts